import React from 'react';

import PropTypes from 'prop-types';

import logo from './logo.png';

import styles from './FacebookLogin.scss';

function FacebookLogin({ onClick, className }) {
    return (
        <button
            className={`${styles.button} ${className}`}
            onClick={onClick}
        >
            <img
                alt="Facebook"
                className={styles.logo}
                src={logo}
            />
            <span
                className={styles.facebookText}
            >
                Facebook
            </span>
        </button>
    );
}

FacebookLogin.propTypes = {
    onClick: PropTypes.func.isRequired,
    className: PropTypes.string,
};

FacebookLogin.defaultProps = {
    className: '',
};

export default FacebookLogin;
